import { CustomDatePicker } from '@components/controls/CustomDatePicker';
import React from 'react';
import Icon from '@amzn/meridian/icon';
import plusKnockoutTokens from '@amzn/meridian-tokens/base/icon/plus-knockout';
import Masthead, { MastheadTitle } from '@amzn/meridian/masthead';
import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import viewTokens from '@amzn/meridian-tokens/base/icon/view';
import Row from '@amzn/meridian/row';
import Alert from '@amzn/meridian/alert';
import StoreSelector from 'src/components/selectors/ProgramStoreSelector';
import FloorplanSelect from 'src/components/agile/zoneViewer/FloorplanSelect';
import { FloorplanSummaryItem } from 'src/store/hooks/useListFloorplans';
import { SwitchButtonValue } from '../types/zoneMapType';

export interface ZoneCreationMenuProps {
  switchButtonValue: string | undefined;
  onClickStoreSelect: (newStoreValue: string) => void;
  handleButtonGroupChange: (newButtonValue: SwitchButtonValue | undefined) => void;
  store: string;
  date: string;
  setDate: (value: string) => void;
  showFloorplanPicker: boolean;
  floorplans: FloorplanSummaryItem[];
  isFloorplansLoading: boolean;
}

const ZoneCreationMenu = (props: ZoneCreationMenuProps) => {
  const {
    switchButtonValue,
    onClickStoreSelect,
    handleButtonGroupChange,
    store,
    date,
    setDate,
    showFloorplanPicker,
    floorplans,
    isFloorplansLoading,
  } = props;

  const showFloorplanSelect = showFloorplanPicker && store && switchButtonValue !== SwitchButtonValue.CopyToNewMap;

  return (
    <Masthead size="large" backgroundColor="surface">
      <MastheadTitle>
        <Row alignmentVertical="bottom">
          <StoreSelector selectedStoreId={store} onStoreSelect={onClickStoreSelect} />
          <CustomDatePicker
            value={date}
            onChange={setDate}
            label="Live Date"
            error={!date && switchButtonValue !== undefined}
            disabledDates={
              switchButtonValue === SwitchButtonValue.CreateZoneMap ||
              switchButtonValue === SwitchButtonValue.CopyToNewMap
                ? (d) => d < new Date().toISOString().split('T')[0]
                : undefined
            }
          />
          {showFloorplanSelect && (
            <FloorplanSelect floorplans={floorplans} isLoading={isFloorplansLoading} date={date} onChange={setDate} />
          )}
          {switchButtonValue !== undefined && (!store || !date) && (
            <Alert size="small" type="error">
              Please select a store and date
            </Alert>
          )}
        </Row>
      </MastheadTitle>
      <ButtonGroup value={switchButtonValue} onChange={handleButtonGroupChange} type="outline" size="medium">
        <ButtonOption value="View Zone Map" disabled={false}>
          <Icon tokens={viewTokens} />
          View zone map
        </ButtonOption>
        <ButtonOption value="Create Zone Map" disabled={false}>
          <Icon tokens={plusKnockoutTokens} />
          Create zone map
        </ButtonOption>
      </ButtonGroup>
    </Masthead>
  );
};

export default ZoneCreationMenu;
